// extracted by mini-css-extract-plugin
export default {"CommitSelectorWrapper":"CommitSelector-module__CommitSelectorWrapper__i8V6ctT","CommitSelectorContainer":"CommitSelector-module__CommitSelectorContainer__EWJVSWy"};